import script from "./GoalDonePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalDonePopup.vue?vue&type=script&setup=true&lang=ts"

import "./GoalDonePopup.vue?vue&type=style&index=0&id=e2e34832&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e34832"]])

export default __exports__